/**
 * converts 5000000001 to 500 000 00 01
 */
export function formatPhoneNumberForDisplay(_number?: string | number) {
  if (!_number) return "";
  let _val: string = _number + "";
  if (_val.length != 10) return "";

  return [
    _val.slice(0, 3),
    _val.slice(3, 6),
    _val.slice(6, 8),
    _val.slice(8, 10),
  ].join(" ");
}
